
export const formatCompanyName = () => {
  let name=process.env.REACT_APP_COMPANY_NAME
    // Remove spaces, capitalize the first letter, and make the rest lowercase
    const noSpaces = name.replace(/\s+/g, '');
    return noSpaces.charAt(0).toUpperCase() + noSpaces.slice(1).toLowerCase();
  };